export default "__VITE_ASSET__BOD00ZKh__"